import React from 'react';
import styles from './last-card-questionnaire.module.scss';
import Emoji from '@/assets/images/emoji-last-card.png';
import { Button, Typography } from '@/ui-kit';
import { useTranslation } from 'react-i18next';

interface Props {
    zIndex?: number;
    onClickOpenFilter: () => void;
}

export const LastCardQuestionnaire: React.FC<Props> = ({ zIndex = 1, onClickOpenFilter }) => {
    const { t } = useTranslation();

    return (
        <div className={styles.wrapper} style={{ zIndex }}>
            <div className={styles.container}>
                <div className={styles.emoji}>
                    <img
                        src={Emoji}
                        width={56}
                        height={56}
                        alt="Emoji" />
                </div>
                <Typography
                    fontWeight="bold"
                    typeColor="white"
                    className={styles.title}
                    fontFamily="SFProText"
                    center>
                    {t('browse.questionnaires_are_over')}
                </Typography>
                <Typography
                    typeColor="white"
                    fontFamily="SFProText"
                    center
                    className={styles.text}
                    fontWeight="normal">
                    {t('browse.empty_list_note')}
                </Typography>
                <Button
                    onClick={onClickOpenFilter}
                    className={styles.button}
                    textColor="black"
                    typeColor="white">
                    {t('browse.open_filter')}
                </Button>
            </div>
        </div>
    );
};
